<template>
  <v-app>
    <Header ref="header"/>
    <Sidebar/>
    <ContentArea>
      <ButtonBar>
        <v-text-field v-model="filter" append-icon="search" :placeholder="$t('filter')" class="filterInput" style="margin-right: 25px;" v-if="!showSearchForm && !currentMember"/>
        <v-btn @click="addSubscription" class="bw-7" style="float: left;" v-if="canEditMemberAccounting && currentMember && currentMember.id > 0">{{ $t('pages.member.button.addSubscription') }}</v-btn>
        <v-btn @click="openSearch" class="bw-6" v-if="!showSearchForm && !currentMember" style="float: left;">{{ $t('pages.member.button.openSearch') }}</v-btn>
        <v-btn @click="showAll" class="bw-3" v-if="filteredSearchResult && !showSearchForm" style="float: left;">{{ $t('pages.member.button.showAll') }}</v-btn>
        <div v-if="!showSearchForm && !currentMember" style="float: left; padding: 6px 40px; display: inline-flex; font-weight: bold; color: #4b526d;">{{ numberOfMembers }}</div>
        <v-btn @click="search" class="bw-3" v-if="showSearchForm" style="float: left;">{{ $t('button.search') }}</v-btn>
        <v-btn @click="resetSearch" class="bw-3" v-if="showSearchForm">{{ $t('button.reset') }}</v-btn>
        <v-btn @click="print" class="bw-3" v-if="!showSearchForm && !currentMember">{{ $t('pages.member.button.print') }}</v-btn>
        <v-btn @click="sendEmail" class="bw-5" v-if="!showSearchForm && !currentMember">{{ $t('pages.member.button.sendEmail') }}</v-btn>
        <v-btn @click="copyEmails" class="bw-5" v-if="!showSearchForm && !currentMember">{{ $t('pages.member.button.copyEmailAddresses') }}</v-btn>
        <v-btn @click="create" class="bw-6" v-if="canEditMember && !showSearchForm && !currentMember">{{ $t('pages.member.button.create') }}</v-btn>
        <v-btn @click="save" :disabled="saveButtonDisabled" class="bw-3" v-if="canEditMember && currentMember">{{ $t('button.save') }}</v-btn>
        <v-btn v-if="canDelete" @click="confirmDeleteDialog = true" class="bw-3">{{ $t('button.delete') }}</v-btn>
        <v-btn @click="close" class="bw-3" v-if="showSearchForm || currentMember">{{ $t('button.close') }}</v-btn>
      </ButtonBar>
      <v-container fluid py-2 px-3 v-if="!showSearchForm && !currentMember" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex class="tableContainer">
            <v-data-table :headers="tableHeaders" :items="members" :search="filter" :custom-filter="customFilter" ref="members" @current-items="setFilteredMembers" hide-default-footer :items-per-page="-1">
              <template v-slot:item="props">
                <tr @click="selectRow(props.item)" class="selectable">
                  <td class="text-xs-left" style="white-space: nowrap; width: 80px;">{{ props.item.number }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.name }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.address.nameAndText }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.phoneNumber }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.email }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.subscriptionStatus }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <Panel :title="$t('pages.member.search.header')" v-if="showSearchForm">
        <PanelColumn2>
          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.number') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="searchMember.number" max-width="75" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.type') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <v-select outlined :items="allTypesWithNull" v-model="searchMember.type" item-text="label" item-value="value" style="width: 130px;"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.supportMember') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <v-select outlined :items="allSupportMemberValues" v-model="searchMember.supportMember" item-text="label" item-value="value" style="width: 75px;"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="showCompanyFieldsSearch">
            <v-label>{{ $t('pages.member.search.fields.companyName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="showCompanyFieldsSearch">
            <TextField v-model="searchMember.companyName" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="showAssociationFieldsSearch">
            <v-label>{{ $t('pages.member.search.fields.associationName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="showAssociationFieldsSearch">
            <TextField v-model="searchMember.associationName" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.firstName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="searchMember.firstName" max-width="300" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="false">
            <v-label>{{ $t('pages.member.search.fields.middleName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="false">
            <TextField v-model="searchMember.middleName" max-width="300" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.lastName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="searchMember.lastName" max-width="300" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="false">
            <v-label>{{ $t('pages.member.search.fields.vat') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="false">
            <TextField v-model="searchMember.vat" max-width="100" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.email') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="searchMember.email" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.phone') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="searchMember.phone" max-width="150" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.search.fields.mobile') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="searchMember.mobile" max-width="150" :keyupEnter="search"/>
          </v-flex>
        </PanelColumn2>
        <PanelColumn2>
          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.search.fields.address') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <table class="noPadding" style="width: 100%;">
              <tr>
                <td style="padding-right: 8px;">
                  <TextField v-model="searchMember.address.street" :keyupEnter="search"/>
                </td>
                <td style="width: 75px;">
                  <TextField v-model="searchMember.address.houseNo" :keyupEnter="search"/>
                </td>
              </tr>
            </table>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.search.fields.location') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="searchMember.address.location" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.search.fields.zipCode') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="searchMember.address.zipCode" max-width="60" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.search.fields.city') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="searchMember.address.city" :keyupEnter="search"/>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.search.fields.country') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="searchMember.address.country" max-width="200" :keyupEnter="search"/>
          </v-flex>
        </PanelColumn2>
      </Panel>
      <Panel :title="$t('pages.member.edit.header.' + (currentMember.id ? 'update' : 'create'))" v-if="currentMember">
        <PanelColumn2>
          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.number') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="currentMember.number" max-width="75" v-if="canEditMember"/>
            <div class="readonlyValue" style="max-width: 75px;" v-html="currentMember.number" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.type') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <v-select outlined :items="allTypes" v-model="currentMember.type" item-text="label" item-value="value" v-if="canEditMember" style="width: 130px;"/>
            <div class="readonlyValue" style="width: 130px;" v-html="typeLabel(currentMember) + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.supportMember') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <v-checkbox v-model="currentMember.supportMember" style="padding-top: 0 !important;" :readonly="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="showCompanyFields">
            <v-label>{{ $t('pages.member.edit.fields.companyName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="showCompanyFields">
            <TextField v-model="currentMember.companyName"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.companyName + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="showAssociationFields">
            <v-label>{{ $t('pages.member.edit.fields.associationName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="showAssociationFields">
            <TextField v-model="currentMember.associationName"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.associationName + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.firstName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="currentMember.firstName" v-if="canEditMember" max-width="300"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.firstName + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="false">
            <v-label>{{ $t('pages.member.edit.fields.middleName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="false">
            <TextField v-model="currentMember.middleName" v-if="canEditMember" max-width="300"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.middleName + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.lastName') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="currentMember.lastName" v-if="canEditMember" max-width="300"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.lastName + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4 v-if="false">
            <v-label>{{ $t('pages.member.edit.fields.vat') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;" v-if="false">
            <TextField v-model="currentMember.vat" v-if="canEditMember" max-width="100"/>
            <div class="readonlyValue" style="max-width: 100px;" v-html="currentMember.vat + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.email') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="currentMember.email" v-if="canEditMember"/>
            <div class="readonlyValue" v-html="currentMember.email + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.phone') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="currentMember.phone" v-if="canEditMember" max-width="150"/>
            <div class="readonlyValue" style="max-width: 150px;" v-html="currentMember.phone + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 sm4>
            <v-label>{{ $t('pages.member.edit.fields.mobile') }}</v-label>
          </v-flex>
          <v-flex xs12 sm8 style="height: 30px;">
            <TextField v-model="currentMember.mobile" v-if="canEditMember" max-width="150"/>
            <div class="readonlyValue" style="max-width: 150px;" v-html="currentMember.mobile + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>
        </PanelColumn2>
        <PanelColumn2>
          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.edit.fields.address') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <table class="noPadding" style="width: 100%;">
              <tr>
                <td style="padding-right: 8px;">
                  <TextField v-model="currentMember.address.street" v-if="canEditMember"/>
                  <div class="readonlyValue" v-html="currentMember.address.street + '&nbsp;'" v-if="!canEditMember"/>
                </td>
                <td style="width: 75px;">
                  <TextField v-model="currentMember.address.houseNo" v-if="canEditMember"/>
                  <div class="readonlyValue" v-html="currentMember.address.houseNo + '&nbsp;'" v-if="!canEditMember"/>
                </td>
              </tr>
            </table>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.edit.fields.location') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="currentMember.address.location" v-if="canEditMember"/>
            <div class="readonlyValue" v-html="currentMember.address.location + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.edit.fields.zipCode') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="currentMember.address.zipCode" v-if="canEditMember" max-width="60"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.address.zipCode + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.edit.fields.city') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="currentMember.address.city" v-if="canEditMember"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.address.city + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>

          <v-flex xs12 md4>
            <v-label>{{ $t('pages.member.edit.fields.country') }}</v-label>
          </v-flex>
          <v-flex xs12 md8 style="height: 30px;">
            <TextField v-model="currentMember.address.country" v-if="canEditMember" max-width="200"/>
            <div class="readonlyValue" style="max-width: 300px;" v-html="currentMember.address.country + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>
        </PanelColumn2>
        <PanelColumn>
          <v-flex xs12>
            <v-label>{{ $t('pages.member.edit.fields.comments') }}</v-label>
          </v-flex>
          <v-flex xs12>
            <TextAreaField v-model="currentMember.comments" rows="8" v-if="canEditMember"/>
            <div class="readonlyValue" style="min-height: 100px; white-space: pre;" v-html="(currentMember.comments ? currentMember.comments : '') + '&nbsp;'" v-if="!canEditMember"/>
          </v-flex>
        </PanelColumn>
        <PanelColumn v-if="currentMember.subscriptions && currentMember.subscriptions.length > 0">
          <v-flex xs12>
            <v-label>{{ $t('pages.member.edit.fields.subscriptions') }}</v-label>
          </v-flex>
          <v-flex xs12 class="tableContainer">
            <v-data-table :headers="subscriptionHeaders" :items="currentMember.subscriptions" hide-default-footer>
              <template v-slot:item="props">
                <tr @click="canEditMemberAccounting ? selectSubscriptionRow(props.item) : null" :class="canEditMemberAccounting ? 'selectable' : ''">
                  <td class="text-xs-left" style="white-space: nowrap; width: 120px;">{{ props.item.created }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.text }}</td>
                  <td class="text-xs-left" style="white-space: nowrap; width: 100px;">{{ $t('subscription.' + props.item.status.toLowerCase()) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </PanelColumn>
      </Panel>
    </ContentArea>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="500">
      <v-card pa-5>
        <v-card-title class="headline">{{ $t('pages.member.dialog.delete.header') }}</v-card-title>
        <v-card-text v-if="currentMember" style="padding-top: 20px;">
          {{ $t('pages.member.dialog.delete.message', { name: currentMember.name }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="deleteMember">{{ $t('button.yes') }}</v-btn>
          <v-btn @click="confirmDeleteDialog = false">{{ $t('button.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createSubscriptionDialog" persistent width="500" v-if="currentSubscription">
      <v-card pa-5>
        <v-card-title class="headline">{{ $t('pages.member.dialog.createSubscription.header') }}</v-card-title>
        <v-card-text style="padding-top: 20px;">
          <v-flex xs12>
            <v-label>{{ $t('pages.member.dialog.createSubscription.text') }}</v-label>
          </v-flex>
          <v-flex xs12>
            <TextField v-model="currentSubscription.text" ref="subscriptionText"/>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="createSubscription">{{ $t('button.create') }}</v-btn>
          <v-btn @click="createSubscriptionDialog = false">{{ $t('button.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editSubscriptionDialog" persistent width="500" v-if="currentSubscription">
      <v-card>
        <v-card-title class="headline">{{ $t('pages.member.dialog.editSubscription.header') }}</v-card-title>
        <v-card-text style="padding-top: 10px;">
          <v-container fluid px-1 py-0>
            <v-layout wrap>
              <v-flex xs12>
                <v-label>{{ $t('pages.member.dialog.editSubscription.text') }}</v-label>
              </v-flex>
              <v-flex xs12>
                <TextField v-model="currentSubscription.text"/>
              </v-flex>
              <v-flex xs2 style="padding-top: 10px;" v-if="!subscriptionCancelled">
                <v-label>{{ $t('pages.member.dialog.editSubscription.paid') }}</v-label>
              </v-flex>
              <v-flex xs10 style="padding-top: 10px;" v-if="!subscriptionCancelled">
                <v-checkbox v-model="subscriptionPaid"/>
              </v-flex>
              <v-flex xs2 style="padding-top: 10px;">
                <v-label>{{ $t('pages.member.dialog.editSubscription.cancelled') }}</v-label>
              </v-flex>
              <v-flex xs10 style="padding-top: 10px;">
                <v-checkbox v-model="subscriptionCancelled"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="saveSubscription">{{ $t('button.save') }}</v-btn>
          <v-btn @click="editSubscriptionDialog = false">{{ $t('button.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import ContentArea from '../components/ContentArea'
import ButtonBar from '../components/ButtonBar'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import TextField from '../components/TextField'
import TextAreaField from '../components/TextAreaField'
import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  name: 'Members',
  data () {
    return {
      filter: null,
      members: [],
      currentMember: null,
      searchMember: null,
      filteredMembers: [],
      showSearchForm: false,
      confirmDeleteDialog: false,
      createSubscriptionDialog: false,
      editSubscriptionDialog: false,
      currentSubscription: null,
      subscriptionPaid: false,
      subscriptionCancelled: false,
      filteredSearchResult: false
    }
  },
  components: { Header, Sidebar, Footer, ContentArea, ButtonBar, Panel, PanelColumn, PanelColumn2, TextField, TextAreaField },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'members' })
    this.loadMembers()
  },
  computed: {
    tableHeaders: function () {
      let headers = [
        { text: this.$t('pages.member.table.columns.number'), value: 'number', sortable: true },
        { text: this.$t('pages.member.table.columns.name'), value: 'name', sortable: true },
        { text: this.$t('pages.member.table.columns.address'), value: 'address.nameAndText', sortable: true },
        { text: this.$t('pages.member.table.columns.phone'), value: 'phoneNumber', sortable: false },
        { text: this.$t('pages.member.table.columns.email'), value: 'email', sortable: false },
        { text: this.$t('pages.member.table.columns.subscription'), value: 'subscriptionStatus', sortable: false }
      ]
      return headers
    },
    subscriptionHeaders: function () {
      let headers = [
        { text: this.$t('pages.member.subscription.table.columns.created'), value: 'created', sortable: false },
        { text: this.$t('pages.member.subscription.table.columns.text'), value: 'text', sortable: false },
        { text: this.$t('pages.member.subscription.table.columns.status'), value: 'text', sortable: false }
      ]
      return headers
    },
    canDelete: function () {
      return this.canEditMember && this.currentMember && this.currentMember.id
    },
    canSave: function () {
      return this.isAdministrator && this.currentMember
    },
    saveButtonDisabled: function () {
      return !this.currentMember || this.currentMember.number.trim() === ''
    },
    allTypes: function () {
      let types = [
        {
          label: this.$t('pages.member.type.private'),
          value: 'PRIVATE'
        },
        {
          label: this.$t('pages.member.type.company'),
          value: 'COMPANY'
        },
        {
          label: this.$t('pages.member.type.association'),
          value: 'ASSOCIATION'
        }
      ]
      return types
    },
    allTypesWithNull: function () {
      let types = [
        {
          label: '',
          value: null
        },
        {
          label: this.$t('pages.member.type.private'),
          value: 'PRIVATE'
        },
        {
          label: this.$t('pages.member.type.company'),
          value: 'COMPANY'
        },
        {
          label: this.$t('pages.member.type.association'),
          value: 'ASSOCIATION'
        }
      ]
      return types
    },
    allSupportMemberValues: function () {
      let values = [
        {
          label: '',
          value: null
        },
        {
          label: this.$t('boolean.false'),
          value: false
        },
        {
          label: this.$t('boolean.true'),
          value: true
        }
      ]
      return values
    },
    showPrivateFields: function () {
      return (this.currentMember && this.currentMember.type === 'PRIVATE')
    },
    showPrivateFieldsSearch: function () {
      return (this.searchMember && this.searchMember.type !== 'COMPANY' && this.searchMember.type !== 'ASSOCIATION')
    },
    showCompanyFields: function () {
      return (this.currentMember && this.currentMember.type === 'COMPANY')
    },
    showCompanyFieldsSearch: function () {
      return (this.searchMember && this.searchMember.type !== 'PRIVATE' && this.searchMember.type !== 'ASSOCIATION')
    },
    showAssociationFields: function () {
      return (this.currentMember && this.currentMember.type === 'ASSOCIATION')
    },
    showAssociationFieldsSearch: function () {
      return (this.searchMember && this.searchMember.type !== 'PRIVATE' && this.searchMember.type !== 'COMPANY')
    },
    isAdministrator: function () {
      return this.$store.getters['session/hasRole'](['ADMIN'])
    },
    canViewMember: function () {
      return this.$store.getters['session/hasRole'](['MEMBER_VIEW'])
    },
    canEditMember: function () {
      return this.$store.getters['session/hasRole'](['MEMBER_EDIT'])
    },
    canEditMemberAccounting: function () {
      return this.$store.getters['session/hasRole'](['MEMBER_ACCOUNTING'])
    },
    numberOfMembers: function () {
      return this.filteredMembers ? this.filteredMembers.length : 0
    }
  },
  methods: {
    loadMembers () {
      axios.get('/backend/ui/member/unpaid')
        .then(response => {
          let members = response.data
          if (members) {
            for (let m of members) {
              m.phoneNumber = this.phoneNumber(m)
              m.subscriptionStatus = m.withSubscriptions ? m.subscriptions && m.subscriptions.length > 0 ? this.$t('subscription.unpaid') : this.$t('subscription.paid') : this.$t('subscription.none')
            }
          }
          this.members = members
        })
    },
    loadSubscriptions () {
      if (this.currentMember) {
        axios.get('/backend/ui/member/' + this.currentMember.id + '/subscriptions')
          .then(response => {
            this.currentMember.subscriptions = response.data
          })
      }
    },
    openSearch () {
      if (!this.searchMember) {
        this.searchMember = {
          number: '',
          type: null,
          name: '',
          firstName: '',
          middleName: '',
          lastName: '',
          companyName: '',
          vat: '',
          associationName: '',
          address: {
            name: '',
            street: '',
            houseNo: '',
            location: '',
            zipCode: '',
            city: '',
            country: '',
            latitude: '',
            longitude: ''
          },
          email: '',
          phone: '',
          mobile: ''
        }
      }
      this.showSearchForm = true
    },
    showAll () {
      this.filteredSearchResult = false
      this.searchMember = null
      this.loadMembers()
    },
    customFilter (value, search, item) {
      if (value != null && typeof value === 'string' && search && search !== '' && (search.toString().toLocaleUpperCase() === 'BETALT' || search.toString().toLocaleUpperCase() === 'PAID')) {
        return value.toString().toLocaleUpperCase() === search.toString().toLocaleUpperCase()
      }
      return value != null && search != null && typeof value === 'string' && value.toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1
    },
    search () {
      axios.post('/backend/ui/member/search/unpaid', this.searchMember)
        .then(response => {
          let members = response.data
          if (members) {
            for (let m of members) {
              m.phoneNumber = this.phoneNumber(m)
              m.subscriptionStatus = m.withSubscriptions ? m.subscriptions && m.subscriptions.length > 0 ? this.$t('subscription.unpaid') : this.$t('subscription.paid') : this.$t('subscription.none')
            }
          }
          this.members = members
          this.filteredSearchResult = true
          this.showSearchForm = false
        })
    },
    resetSearch () {
      this.searchMember = null
      this.openSearch()
    },
    create () {
      this.currentMember = {
        id: null,
        number: '',
        type: 'PRIVATE',
        supportMember: false,
        name: '',
        firstName: '',
        middleName: '',
        lastName: '',
        companyName: '',
        vat: '',
        associationName: '',
        address: {
          name: '',
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        },
        email: '',
        phone: '',
        mobile: '',
        comments: ''
      }
    },
    save () {
      delete this.currentMember.phoneNumber
      delete this.currentMember.subscriptionStatus

      axios.post('/backend/ui/member', this.currentMember)
        .then(response => {
          this.loadMembers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentMember = null
    },
    deleteMember () {
      axios.delete('/backend/ui/member/' + this.currentMember.id)
        .then(response => {
          this.loadMembers()
          this.currentMember = null
          this.confirmDeleteDialog = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    close () {
      this.showSearchForm = false
      this.currentMember = null
    },
    selectRow (member) {
      axios.get('/backend/ui/member/' + member.id)
        .then(response => {
          this.currentMember = response.data

          axios.get('/backend/ui/member/' + member.id + '/subscriptions')
            .then(response => {
              this.currentMember.subscriptions = response.data
            })
            .catch(error => {
              console.log(error.response.data.message)
            })
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    selectSubscriptionRow (subscription) {
      this.currentSubscription = subscription
      this.subscriptionPaid = subscription.status === 'PAID'
      this.subscriptionCancelled = subscription.status === 'CANCELLED'
      this.editSubscriptionDialog = true
    },
    phoneNumber (member) {
      let phoneNumber = ''
      if (member) {
        if (member.phone !== '') {
          phoneNumber += member.phone
        }
        if (member.mobile !== '') {
          if (phoneNumber !== '') {
            phoneNumber += ' / '
          }
          phoneNumber += member.mobile
        }
      }
      return phoneNumber
    },
    typeLabel (member) {
      if (member.type === 'PRIVATE') {
        return this.$t('pages.member.type.private')
      } else if (member.type === 'COMPANY') {
        return this.$t('pages.member.type.company')
      } else if (member.type === 'ASSOCIATION') {
        return this.$t('pages.member.type.association')
      }
      return ''
    },
    addSubscription () {
      this.currentSubscription = {
        id: 0,
        member: {
          id: this.currentMember.id
        },
        status: 'UNPAID',
        text: ''
      }
      this.createSubscriptionDialog = true
      this.$nextTick(() => this.$refs.subscriptionText.focus())
    },
    createSubscription () {
      axios.post('/backend/ui/member/subscription', this.currentSubscription)
        .then(response => {
          this.loadSubscriptions()
          this.loadMembers()
          this.createSubscriptionDialog = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    saveSubscription () {
      this.currentSubscription.status = this.subscriptionCancelled ? 'CANCELLED' : this.subscriptionPaid ? 'PAID' : 'UNPAID'
      axios.post('/backend/ui/member/subscription', this.currentSubscription)
        .then(response => {
          this.loadSubscriptions()
          this.loadMembers()
          this.editSubscriptionDialog = false
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    setFilteredMembers (members) {
      this.filteredMembers = members
    },
    print () {
      let filteredItems = this.filteredMembers
      let memberIds = []
      for (let member of filteredItems) {
        memberIds.push(member.id)
      }
      let params = 'locale=' + i18n.locale + '&members=' + memberIds.join(',')
      axios.post('/backend/print/members.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Members.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Members.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    sendEmail () {
      let filteredItems = this.filteredMembers
      let emailAddresses = []
      for (let member of filteredItems) {
        if (member.email && member.email.trim().length > 0 && member.email.includes('@')) {
          emailAddresses.push(member.email)
        }
      }
      let bcc = emailAddresses.join(', ')
      document.location = ' mailto:?bcc=' + bcc
    },
    copyEmails () {
      let filteredItems = this.filteredMembers
      let emailAddresses = []
      for (let member of filteredItems) {
        if (member.email && member.email.trim().length > 0 && member.email.includes('@')) {
          emailAddresses.push(member.email)
        }
      }

      navigator.clipboard.writeText(emailAddresses.join('; ')).then(() => {
        this.$refs.header.showSnackbar(this.$t('pages.member.snackbar.copyEmailAddresses.succeed'))
      })
    }
  }
}
</script>

<style>
.readonlyValue {
  font-size: 10pt;
  line-height: 20px;
  border: 1px solid rgba(75, 82, 109, 0.5);
  border-radius: 3px;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Members.vue